import { Checkbox, Input, Label } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function LabelDemo() {
  return (
    <Section
      id="label"
      title="Label"
      description="Form-control label. Peer-aware: dims when its target is disabled."
    >
      <VariantBlock label="Implicit association (nested)">
        <Label className="flex items-center gap-2">
          <Checkbox />
          <span>Subscribe to updates</span>
        </Label>
      </VariantBlock>

      <VariantBlock label="Explicit (htmlFor)">
        <div className="grid w-72 gap-1.5">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" placeholder="you@example.com" />
        </div>
      </VariantBlock>

      <VariantBlock label="Peer-disabled dimming">
        <div className="grid w-72 gap-1.5">
          <Label htmlFor="locked">Locked field</Label>
          <Input id="locked" disabled defaultValue="—" className="peer" />
        </div>
      </VariantBlock>
    </Section>
  );
}
